exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts[data-v-1ea97711]{padding:20px 0;color:hsla(0,0%,100%,.65);background:url(\"/images/web/footer.png\") 50%;background-size:100% 100%}.contacts a[data-v-1ea97711]{color:hsla(0,0%,100%,.65)}.contacts .tl[data-v-1ea97711],.contacts a[data-v-1ea97711]:hover{color:#fff}.contacts .tel[data-v-1ea97711]{display:block;line-height:3}.contacts .main>.el-col[data-v-1ea97711]{padding-right:110px}.contacts .main>.el-col[data-v-1ea97711]:last-child{padding-right:0}.contacts .main .text[data-v-1ea97711]{line-height:2.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ea97711","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/contacts/index.vue
// module id = 03os
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37